function getCookie(cname) {
  const name = cname + "="
  const decodedCookie = decodeURIComponent(document.cookie)
  const foundCookie = decodedCookie.split(';')
    .find(cookie => cookie.trim().startsWith(name))
  return foundCookie ? foundCookie.trim().replace(name, '').replace(/"/g, '') : '';
}

const userCookie = getCookie('prc-user')

const userState = userCookie.split('|').reduce((agg, curr) => {
  const kvPair = curr.split(':');
  agg[kvPair[0]] = kvPair[1] === "" ? null : kvPair[1];
  return agg;
}, {});

const mockAuthState = {
  username: 'TEST.USER1',
  roles: 'STUDENT',
  authToken: '123testtoken'
};

const initialState = (String(process.env.REACT_APP_MOCK_API) === 'true') ?
  mockAuthState :
  userState;
export default (state = initialState) => {
    return state;
}
